<template>
  <q-input
    outlined
    v-model="model"
    :label="label"
    :error="error"
    hide-bottom-space
    mask="##-##-####"
    :readonly="readonly"
  >
    <template
      v-for="(_, slot) in $slots"
      v-slot:[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope || {}"
      />
    </template>
    <template v-slot:append>
      <q-icon
        v-if="!readonly"
        name="event"
        class="cursor-pointer"
      >
        <q-popup-proxy
          cover
          transition-show="scale"
          transition-hide="scale"
        >
          <q-date
            v-model="model"
            mask="DD-MM-YYYY"
          >
            <div class="row items-center justify-end">
              <q-btn
                v-close-popup
                label="Close"
                color="primary"
                flat
              />
            </div>
          </q-date>
        </q-popup-proxy>
      </q-icon>
    </template>
    <template v-slot:error>
      <span
        v-for="err in errors"
        :key="err"
        >{{ err }}</span
      >
    </template>
  </q-input>
</template>

<script setup>
import { computed } from 'vue';

const model = defineModel({ type: [String, Number, Date] });

const props = defineProps({
  errors: [String, Array],
  label: [String],
  readonly: {
    type: Boolean,
    default: false,
  },
});

const error = computed(() => props.errors && props.errors.length !== 0);
</script>
